import { InputAdornment, NumberInput as UINumberInput } from '@cian/ui-kit';
import { clsx } from 'clsx';
import * as styles from './NumberInput.css';

interface INumberInputProps {
  onChange: (value: number | undefined) => void;
  onBlur?: () => void;
  value: number | undefined;
  leftAdornment?: string;
  rightAdornment?: string;
  invalid?: boolean;
  max?: number;
  min?: number;
  small?: boolean;
}

export function NumberInput(props: INumberInputProps) {
  const { onChange, value, onBlur, leftAdornment, rightAdornment, invalid, small, min, max } = props;

  return (
    <div className={clsx(styles['container'], small && styles['container__small'])}>
      <UINumberInput
        leftAdornment={leftAdornment && <InputAdornment>{leftAdornment}</InputAdornment>}
        rightAdornment={rightAdornment && <InputAdornment>{rightAdornment}</InputAdornment>}
        onBlur={onBlur}
        onChange={onChange}
        invalid={invalid}
        max={max}
        min={min}
        value={value}
      />
    </div>
  );
}
